export const portNoAreaOption = { name: 'Port with no area', id: 'port_no_area' };
export const portNoCountryOption = { name: 'Port with no country', id: 'port_no_country' };
